import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import type { CSSProperties, MouseEventHandler, ReactNode } from "react";

const useStyles = makeStyles({
  primaryButton: {
    width: "100%",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    backgroundColor: "#F50561",
    borderRadius: "32px",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    padding: "8px 16px",

    "&:hover": {
      backgroundColor: "#F50561",
    },

    "&.Mui-disabled": {
      opacity: "0.5",
      backgroundColor: "#757575",
      color: "#fff",
    },
  },
});

interface PrimaryButtonProps {
  readonly children: ReactNode;
  readonly onClick: MouseEventHandler<HTMLButtonElement>;
  readonly style: CSSProperties;
}

export default function PrimaryButton(props: PrimaryButtonProps) {
  const { children, ...rest } = props;
  const classes = useStyles();

  return (
    <Button className={classes.primaryButton} {...rest}>
      {children}
    </Button>
  );
}
